import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import classes from "./Navbar.module.css";
import logo from "../../assets/img/logo.svg";
import { Search } from "../";
import i18next from "i18next";
import { Avatar } from "../index";
import { Dropdown } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [toggleSearch, setToggleSearch] = useState(false);
  const { t, i18n } = useTranslation();
  const [navs, setNavs] = useState([
    {
      id: 1,
      title: "restaurants",
    },
    {
      id: 2,
      title: "coffees",
    },
    {
      id: 3,
      title: "hotels",
    },
  ]);

  // Change Language
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    const bodyEl = document.body;
    if (language == "ar") {
      bodyEl.classList.add("body-rtl");
    } else {
      bodyEl.classList.remove("body-rtl");
    }
  };
  if (localStorage.getItem("i18nextLng")) {
    const bodyEl = document.body;
    if (localStorage.getItem("i18nextLng") == "ar") {
      bodyEl.classList.add("body-rtl");
    } else {
      bodyEl.classList.remove("body-rtl");
    }
  }

  return (
    <nav id="mainNavbar" className={classes.nav}>
      {toggleSearch ? <Search className={classes.searchContainerNav} /> : ""}
      <div className={`container`}>
        <div className={classes.navbar}>
          <NavLink to="/" className={classes.navLogo}>
            <img src={logo} className={`img-fluid ${classes.navLogoView}`} />
          </NavLink>
          <div className={classes.navLinks}>
            {/* <div className={classes.navDropdown}>
              <NavLink to="/Home" className={classes.navLink}>
                Home
              </NavLink>
            </div> */}
            <div className={classes.navDropdown}>
              <NavLink to="/" className={classes.navLink}>
                Home
                {/* <FontAwesomeIcon
                  className={classes.arrowDown}
                  icon={faAngleDown}
                /> */}
              </NavLink>
              {/* <div className={classes.navDropdownList}>
                {navs.map((nav, index) => {
                  return (
                    <NavLink
                      key={index}
                      to="/"
                      className={classes.dropdownLink}
                    >
                      {nav.title}
                    </NavLink>
                  );
                })}
              </div> */}
            </div>
            <div className={classes.navDropdown}>
              <NavLink to="/menu" className={classes.navLink}>
                Menu
              </NavLink>
            </div>
            <div className={classes.navDropdown}>
              <NavLink to="/about" className={classes.navLink}>
                About
              </NavLink>
            </div>
            <div className={classes.navDropdown}>
              <NavLink to="/contact" className={classes.navLink}>
                Contact Us
              </NavLink>
            </div>
            <div className={classes.navDropdown}>
              <NavLink
                to="/login"
                className={`${classes.navLink} ${classes.navAuth}`}
              >
                Login
              </NavLink>
            </div>
            <div className={classes.navDropdown}>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <Avatar className={classes.avatar} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <NavLink
                    className={`dropdown-item ${classes.dropdownLink}`}
                    to="/profile"
                  >
                    Profile
                  </NavLink>
                  <NavLink
                    className={`dropdown-item ${classes.dropdownLink}`}
                    to="/logout"
                  >
                    Logout
                  </NavLink>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className={classes.navDropdown}>
              <NavLink
                to="/cart"
                className={`${classes.navIcon} ${classes.navCart}`}
              >
                <span className={`icon-cart ${classes.iconCart}`}></span>
                <div className={classes.cartCounter}>
                  <div>5</div>
                </div>
              </NavLink>
            </div>
            <div className={classes.navDropdown}>
              <button
                onClick={() => setToggleSearch(!toggleSearch)}
                className={`${classes.navIcon}`}
              >
                {toggleSearch ? (
                  <span className={`icon-cancel`}></span>
                ) : (
                  <span className={`icon-search`}></span>
                )}
              </button>
            </div>
            <div className={classes.navDropdown}>
              <button
                className={classes.toggleLang}
                onClick={() =>
                  changeLanguage(i18next.language == "ar" ? "en" : "ar")
                }
              >
                <span className={`icon-globe ${classes.iconGlobe}`}></span>
                <div className={classes.langText}>
                  {i18next.language == "ar" ? "EN" : "AR"}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export { Navbar };
